<script>
export default {
  name: "VModal",
  props: {
    name: String,
    title:String,
    type:{type:String,default:"primary"},
    submitBtn:{default:"Submit"},
    noFooter:Boolean,
  },
  mounted(){
    $("#"+this.name).on('show.bs.modal', ()=>{
      $(this.$el).find("form").validate().resetForm()
    });
  },
  methods:{
    submitForm(e){
      this.$emit("resp", e)
    }
  }
}
</script>

<template>
  <div :id="name" class="modal fade">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
          <h4 class="modal-title">{{title}}</h4>
        </div>
        <VForm @resp="submitForm" method="post">
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer" v-if="!noFooter">
            <slot name="footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              <button v-if="submitBtn" type="submit" class="btn btn-primary btn-loading">{{submitBtn}}</button>
            </slot>
          </div>
        </VForm>
      </div>
    </div>
  </div>
</template>